var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right"},[_c('centered-user'),_c('div',{staticClass:"right-other"},[_c('div',{staticClass:"right-other-left"},[_c('centered-order'),_c('centered-recommend')],1),_c('div',{staticClass:"right-other-right"},[_c('Centerde_manager'),_c('centerde-follow'),_c('centerde-used')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }